export default "__VITE_PUBLIC_ASSET__b793b55e__"